module.exports = __webpack_public_path__ + "img/database.816f7a99.png";